import { render, staticRenderFns } from "./QuillEditor.vue?vue&type=template&id=2c9569e2&"
import script from "./QuillEditor.vue?vue&type=script&lang=js&"
export * from "./QuillEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports